interface LogitoChoiceOption {
    value: string;
    text: string;
    selected: boolean;
    key?: string;
}

// Trzyma opcje choice per endpoint
export const choiceOptionsCache = new Map<string, Promise<LogitoChoiceOption[]>>();
